import { z } from 'zod';
import { product } from '../Product';
import { categoryFilter } from '../CategoryFilter';

export const productGroupSummary = z.object({
    categoryFilter,
    products: z.array(product),
    totalQuantity: z.number().int().nonnegative()
});

export type ProductGroupSummary = z.infer<typeof productGroupSummary>;
